import { Stack, Typography } from "@mui/material"
import { HighlightedText, Link } from "@tc/ui-dfe/components"

export const RequestInfo = (props: {
  request: string
  status: string
  queryText?: string
  isNonConsignmentCertificate?: boolean
}) => {
  const { request, queryText, isNonConsignmentCertificate } = props

  return (
    <Stack
      direction={"row"}
      alignItems="center"
      spacing={1.5}
      sx={{ minHeight: 40 }}
    >
      <Stack
        sx={{
          display: {
            xs: "none",
            md: "flex",
          },
        }}
      ></Stack>
      <Stack alignItems="flex-start">
        <Typography gutterBottom variant="h6" color="forest">
          <HighlightedText
            text={isNonConsignmentCertificate ? "" : request || "-"}
            highlight={queryText ?? ""}
          />
        </Typography>
      </Stack>
    </Stack>
  )
}

export const Certificate = (props: {
  certificate_number: string
  id: string
  queryText?: string
  href?: string
}) => {
  const { certificate_number, queryText, href } = props

  const renderText = () => {
    if (queryText) {
      return <HighlightedText text={certificate_number} highlight={queryText} />
    }
    return certificate_number
  }

  if (!certificate_number) {
    return null
  }

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      flexWrap="wrap"
      gap={1}
      sx={{ py: 0.5 }}
    >
      {href ? (
        <Link href={href} custom>
          <Typography color="forest" variant="h6">
            {renderText()}
          </Typography>
        </Link>
      ) : (
        <Typography>{renderText()}</Typography>
      )}
    </Stack>
  )
}
